import { useContext } from 'react'

import { AlertContext } from '../context/AlertProvider'

export { useAlerts }

const useAlerts = () => {
  const context = useContext(AlertContext)

  /* v8 ignore next -- @preserve */
  if (!context) {
    throw Error('This hook needs to be wrapped in an AlertProvider to function')
  }

  return context
}
